var _defs, _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgCompanyLogo = function SvgCompanyLogo(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 123,
    viewBox: "0 0 123 123",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "prefix__d",
    d: "M0 0L119 0 119 118.919 0 118.919z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__f",
    d: "M0.128 0.527L84.254 0.527 84.254 28.108 0.128 28.108z"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "prefix__b",
    width: "117.8%",
    height: "117.8%",
    x: "-8.9%",
    y: "-7.1%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    operator: "dilate",
    radius: 2.7,
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    radius: 2.7,
    result: "shadowInner"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    in: "shadowInner",
    result: "shadowInner"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetOuter1",
    in2: "shadowInner",
    operator: "out",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0.588235294 0 0 0 0 0.588235294 0 0 0 0 0.588235294 0 0 0 0.541220498 0"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__a",
    cx: 54.5,
    cy: 54.5,
    r: 54.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(7 5)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#prefix__b)",
    xlinkHref: "#prefix__a"
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "#FFF",
    strokeWidth: 5.4,
    xlinkHref: "#prefix__a"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#prefix__c)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-5)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__e",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__d"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M103.364 99.63a50.935 50.935 0 01-1.802 1.88 59.017 59.017 0 01-2.094 1.997c-10.572 9.573-24.585 15.412-39.968 15.412-15.383 0-29.397-5.839-39.968-15.412a59.016 59.016 0 01-2.094-1.998 53.485 53.485 0 01-1.801-1.874C5.927 89.058 0 74.947 0 59.459 0 26.622 26.64 0 59.5 0S119 26.622 119 59.46c0 15.487-5.927 29.598-15.636 40.17z",
    mask: "url(#prefix__e)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.31 90.81)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__g",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__f"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#EBF0F7",
    d: "M84.254 10.699a59.094 59.094 0 01-2.096 1.998c-10.57 9.572-24.584 15.412-39.967 15.412s-29.397-5.84-39.968-15.412a60.008 60.008 0 01-2.095-1.998 25.028 25.028 0 018.073-3.176l19.504-4.011 2.158-.444 8.433-1.737.693-.142 3.202-.662 3.666.752.24.048 8.399 1.733 2.181.448 19.504 4.015c2.923.594 5.64 1.69 8.073 3.176",
    mask: "url(#prefix__g)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#CBD2DF",
    d: "M33.699 16.078L57.657 3.107 57.705 101.102 33.745 101.102z",
    transform: "translate(2 11)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CBD2DF",
    d: "M57.657 3.107L85.968 21.343 85.968 100.737 54.773 101.102z",
    transform: "translate(2 11)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EAEFF7",
    d: "M37.322 18.411L55.183 8.971 55.183 97.759 37.322 97.759z",
    transform: "translate(2 11)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CBD2DF",
    d: "M18.031 70.587L34.203 66.014 34.426 100.914 18.125 100.914z",
    transform: "translate(2 11)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CBD2DF",
    d: "M34.425 66.47L44.605 72.885 44.605 100.784 33.1 100.913z",
    transform: "translate(2 11)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EAEFF7",
    d: "M20.235 72.052L32.689 68.898 32.689 98.534 20.235 98.534z",
    transform: "translate(2 11)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CBD2DF",
    d: "M61.598 51.905L79.963 45.209 79.963 101.102 61.739 101.102z",
    transform: "translate(2 11)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CBD2DF",
    d: "M79.963 45.209L96.463 55.611 96.463 100.913 77.77 101.102z",
    transform: "translate(2 11)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EAEFF7",
    d: "M63.24 54.919L78.087 49.653 78.087 99.178 63.24 99.178z",
    transform: "translate(2 11)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CBD2DF",
    d: "M0 118.081L116.651 118.081 116.651 97.208 0 97.208zM57.845 0L57.059.41 36.994 11.222 36.994 14.331 57.705 3.53 83.81 20.194 83.81 16.77 58.572.503zM34.425 63.856L33.968 63.996 20.775 67.749 20.775 70.001 34.062 66.143 43.362 72.428 43.362 69.766 34.847 64.137zM78.778 41.221L78.086 41.55 63.931 47.964 65.128 50.568 78.544 44.481 95.314 55.106 95.314 51.811 79.411 41.643z",
    transform: "translate(2 11)"
  })))))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCompanyLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/company-logo.352b527e.svg";
export { ForwardRef as ReactComponent };